import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {ModalFormButton} from "../components/modal-form-button/modal-form-button";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-modal-form-button",ModalFormButton);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
